/**
 * Configuration des polices Google Fonts
 * 
 * - Playfair Display : Titres / marque / aventures
 * - Merriweather : Texte de lecture (le plus important)
 * - EB Garamond : Texte de jeu (mode normal, style livre ancien)
 * - Source Sans 3 : UI / méta / filtres / stats
 */

import {Platform} from 'react-native';

export const Fonts = {
  // Titres / marque / aventures
  title: Platform.OS === 'web' ? 'Playfair Display, serif' : 'PlayfairDisplay-Regular',
  
  // Texte de lecture (le plus important) - Mode lecture
  reading: Platform.OS === 'web' ? 'Merriweather, serif' : 'Merriweather-Regular',
  
  // Texte de jeu - Mode normal (style livre ancien)
  narrative: Platform.OS === 'web' ? 'EB Garamond, serif' : 'EBGaramond-Regular',
  
  // UI / méta / filtres / stats
  ui: Platform.OS === 'web' ? 'Source Sans 3, sans-serif' : 'SourceSans3-Regular',
} as const;

// Variantes de poids pour chaque police
export const FontWeights = {
  title: {
    regular: Platform.OS === 'web' ? 'Playfair Display, serif' : 'PlayfairDisplay-Regular',
    semibold: Platform.OS === 'web' ? 'Playfair Display, serif' : 'PlayfairDisplay-SemiBold',
    bold: Platform.OS === 'web' ? 'Playfair Display, serif' : 'PlayfairDisplay-Bold',
  },
  reading: {
    light: Platform.OS === 'web' ? 'Merriweather, serif' : 'Merriweather-Light',
    regular: Platform.OS === 'web' ? 'Merriweather, serif' : 'Merriweather-Regular',
    bold: Platform.OS === 'web' ? 'Merriweather, serif' : 'Merriweather-Bold',
  },
  narrative: {
    regular: Platform.OS === 'web' ? 'EB Garamond, serif' : 'EBGaramond-Regular',
    medium: Platform.OS === 'web' ? 'EB Garamond, serif' : 'EBGaramond-Medium',
    semibold: Platform.OS === 'web' ? 'EB Garamond, serif' : 'EBGaramond-SemiBold',
    bold: Platform.OS === 'web' ? 'EB Garamond, serif' : 'EBGaramond-Bold',
  },
  ui: {
    regular: Platform.OS === 'web' ? 'Source Sans 3, sans-serif' : 'SourceSans3-Regular',
    medium: Platform.OS === 'web' ? 'Source Sans 3, sans-serif' : 'SourceSans3-Medium',
    semibold: Platform.OS === 'web' ? 'Source Sans 3, sans-serif' : 'SourceSans3-SemiBold',
  },
} as const;
